import script from "./ShopCertification.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopCertification.vue?vue&type=script&setup=true&lang=js"

import "./ShopCertification.vue?vue&type=style&index=0&id=f168d420&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f168d420"]])

export default __exports__